/**
 * QA / test accounts that skip the max-device UI limit (normally 2 devices).
 * Keep in sync with backend/src/constants/unlimited-device-usernames.ts
 */
export const UNLIMITED_DEVICE_USERNAMES = [
  "isaque",
  "roger",
  "gomes",
  "teste",
] as const;

export function isUnlimitedDeviceUsername(
  userName?: string | null,
): boolean {
  if (!userName) return false;
  const normalized = userName.trim().toLowerCase();
  return (UNLIMITED_DEVICE_USERNAMES as readonly string[]).includes(normalized);
}
